import { Box } from '@mui/material'
import StatusBtn from '../../atoms/status/StatusBtn'
import TableData from '../../atoms/table/TableData'
import { statusData } from '../../../util/constants'

export default function VendorTrackerTable({ rows }) {
	const columns = [
		{
			field: 'Vendor',
			headerName: 'Vendor',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'BidAmount',
			headerName: 'Vendor’s Bid',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'Status',
			headerName: 'Proposal Status',
			flex: 1,
			minWidth: 100,
			renderCell: (params) => {
				const status = statusData.find(
					(item) => item.status === params.value
				)
				return (
					<StatusBtn
						size="small"
						label={status?.label || params.value}
						variant={status?.variant || 'default'}
					/>
				)
			},
		},
	]

	return (
		<div style={{ gridTemplateColumns: '1fr 1fr' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					// height: 'calc(100vh - 420px)',
					// height: '100%',
					// minHeight: 200,
					'@media (max-width: 900px)': {
						// height: 'calc(100vh - 390px)',
					},
				}}
			>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					<TableData
						hideFooter={true}
						rows={rows}
						columns={columns}
						height="310px"
						checkboxSelection={false}
						sx={
							{
								// height: 'calc(100dvh - 200px)',
								// '@media (max-width: 768px)': {
								// 	height: 'calc(100dvh - 260px)',
								// },
							}
						}
					/>
				</Box>
			</Box>
		</div>
	)
}
